import type {Boroughs, CenterVideoCallInfo} from '../types';
import {Row, SelectButton} from '../types/VideoCallPage.styled.ts';
import useVideoCallStore from '../../../store/useVideoCallStore.ts';
import type {FC} from 'react';
import {useFocusable} from '@noriginmedia/norigin-spatial-navigation';

interface CenterListProps {
    selectedBoroughsName: string;
    centerVideoCallInfo: CenterVideoCallInfo;
}

const CenterList: FC<CenterListProps> = ({selectedBoroughsName, centerVideoCallInfo}) => {
    const {selectedCenterVideoCallInfoAry, setCenterVideoCallInfo} = useVideoCallStore();

    const {ref, focused} = useFocusable({
        focusKey: `${centerVideoCallInfo.id}-${centerVideoCallInfo.name}`,
        onEnterPress: () => setCenterVideoCallInfo(centerVideoCallInfo),
        onFocus: () => {
            if (ref.current) {
                ref.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
        },
    });

    return (
        <>
            <Row key={centerVideoCallInfo.id}>
                <span>{selectedBoroughsName}</span>
                <span>{centerVideoCallInfo.centerid}</span>
                <span style={{flex: 2}}>{centerVideoCallInfo.name}</span>
                <SelectButton
                    ref={ref}
                    $focused={focused}
                    onClick={() => setCenterVideoCallInfo(centerVideoCallInfo)}
                    $selected={selectedCenterVideoCallInfoAry.some((c) => c.id === centerVideoCallInfo.id)}
                >
                    {selectedCenterVideoCallInfoAry.some((c) => c.id === centerVideoCallInfo.id)
                        ? '선택해제'
                        : '선택하기'}
                </SelectButton>
            </Row>
        </>
    );
};

export default CenterList;
